app.controller('EmployeeNewInternalDocumentController', ['$scope', '$uibModal', 'AuthService', 'StaticData', 'DocumentsService', '$http', 'usSpinnerService', 'toastr', '$state', '$rootScope', 'Hr',
    function ($scope, $uibModal, AuthService, StaticData, DocumentsService, $http, usSpinnerService, toastr, $state, $rootScope, Hr) {
        $scope.isRoot = false;
        $scope.format = "dd-MM-yyyy";
        $scope.documentTypes = {
            'INNER': [],
            'OUTER': []
        };
        $scope.type = null;
        $scope.documentAddressees = {
            'UNIT': [],
            'PERSON': []
        };
        $scope.addresseeType = null;
        $scope.comment = '';
        $scope.topic = '';
        $scope.resolutionComment = '';
        $scope.addressees = [];
        $scope.addressee = [];
        $scope.attachments = [];
        $scope.infos = [];
        $scope.author = null;
        $scope.pickerPopup = { opened: false };
        $scope.action = 'create';
        $scope.isForStudent = null;
        $scope.documentFile = null;
        $scope.sheetsNumber = '';
        $scope.basisFileNumber = null;
        $scope.basisFile = null;
        $scope.basisFiles = [];
        $scope.deadLine = null;
        $scope.dateOptions = {
            "is-open": "false",
            dateDisabled: false,
            formatYear: 'yyyy',
            minDate: new Date(),
            startingDay: 1
        };

        AuthService.getUserData().then(function (user) {
            $scope.profile = user.profiles.filter(function (p) {
                return p.type === "employee" && p.state === 'active'
            })[0];

            if ($scope.profile.positionInfo) {
                AuthService.isRoot = $scope.profile.positionInfo.isRoot;
                $scope.isRoot = AuthService.isRoot;
            }
        });

        $scope.getEmployees = function (name) {
            if (name.length < 1) {
                return [];
            }
            return DocumentsService.staffList({
                query: name
            }).then(function (data) {
                return data.docs;
            });
        };

        $scope.getData = function () {
            $scope.documentTypes = {
                'INNER': [],
                'OUTER': []
            };
            $scope.documentAddressees = {
                'UNIT': [],
                'PERSON': []
            };
            if ($scope.author && $scope.author._id) {
                DocumentsService.typeList({ admin: false, userId: $scope.author.user._id }).then(function (data) {
                    data.forEach(function (type) {
                        $scope.documentTypes[type.parentId].push(type)
                    });
                }).catch(function () {
                    usSpinnerService.spin("root");
                    toastr.error('', 'დაფიქსირდა შეცდომა');
                });

                DocumentsService.getDocumentAddressee({ userId: $scope.author.user._id, isResolustion: $scope.action == 'resolve' }).then(function (data) {
                    data.forEach(function (addressee) {
                        if (addressee.isUnit)
                            $scope.documentAddressees['UNIT'].push(addressee);
                        else
                            $scope.documentAddressees['PERSON'].push(addressee);

                    });
                }).catch(function () {
                    usSpinnerService.spin("root");
                    toastr.error('', 'დაფიქსირდა შეცდომა');
                });
            }
        }

        $scope.addToBasis = function () {
            $scope.basisFiles.push($scope.basisFileNumber);
            $scope.basisFileNumber = null;
        };

        $scope.deleteAddressee = function (id) {
            var el_index = _.findIndex($scope.addressees, function (addr) {
                return id === addr._id;
            });

            $scope.addressees.splice(el_index, 1);
        };

        $scope.getDocumentNumbers = function (query) {
            if (query.length < 1) {
                return [];
            }
            return DocumentsService.getDocumentNumbers({
                uniqueNumber: query
            }).then(function (data) {
                return data;
            });
        };

        $scope.send = function () {
            if (!$scope.type) toastr.error('', 'გთხოვთ მიუთითოთ დოკუმენტის ტიპი');
            else if (!$scope.addressees.length && !$scope.addresseeType) toastr.error('', 'გთხოვთ მიუთითოთ ადრესატი');
            else if (!$scope.documentFile || !$scope.documentFile._id) toastr.error('', 'გთხოვთ დაურთოთ დოკუმენტი ფაილად');
            else {
                usSpinnerService.spin("root");
                DocumentsService.send({
                    userId: $scope.author.user._id,
                    baseDraftDocument: $scope.documentId,
                    type: $scope.type,
                    comment: $scope.comment,
                    topic: $scope.topic,
                    addressees: $scope.addressees.map(function (item) {
                        let addressee = null;
                        if (item.isUnit) {
                            addressee = item;
                            addressee.info = { _id: item._id };
                        } else {
                            addressee = _.omit(item, 'profile');
                            addressee.info = { _id: item.profile._id };
                        }

                        return addressee;
                    }),
                    addresseeType: $scope.addresseeType,
                    attachments: $scope.attachments,
                    // basisDocs: basisDocs,
                    sheetsNumber: $scope.sheetsNumber,
                    deadline: $scope.deadLine,
                    documentFile: $scope.documentFile._id,
                }).then(function () {
                    usSpinnerService.spin("root");
                    toastr.success('', 'დოკუმენტი გაგზავნილია');
                    $rootScope.documentsCount();
                    $state.go('employee.documents.sent')
                }).catch(function () {
                    usSpinnerService.spin("root");
                    toastr.error('', 'დოკუმენტის გაგზავნისას დაფიქსირდა შეცდომა');
                })
            }
        };

        $scope.uploadAttachment = function (type, files) {
            usSpinnerService.spin("root");
            $scope.file = files[0];
            var fd = new FormData();
            if ($scope.file && $scope.file.name) {
                fd.append('file', $scope.file, $scope.file.name);
                $http.post('/documents/attachments', fd, {
                    headers: { 'Content-Type': undefined }
                }).then(function (response) {
                    if (type === 'basis') {
                        $scope.basisFiles.push(response.data);
                    } else if (type === 'attachment') {
                        $scope.attachments.push(response.data);
                    } else {
                        $scope.documentFile = response.data;
                    }
                    $scope.fileName = response.data.name;

                    usSpinnerService.stop("root");
                })
            }
        };

        $scope.removeAttachment = function (type, file) {
            usSpinnerService.spin("root");
            if (type === 'basis' && !file.location) {
                for (var i in $scope.basisFiles) {
                    if (!$scope.basisFiles[i].location && file.name === $scope.basisFiles[i].name) {
                        $scope.basisFiles.splice(i, 1);
                        usSpinnerService.stop("root");
                    }
                }
            } else if (file.location) {
                DocumentsService.removeAttachment(file._id).then(function () {
                    var elementIndex;
                    if (type === 'basis') {
                        elementIndex = _.findIndex($scope.basisFiles, function (basisFile) {
                            return basisFile._id === file._id;
                        });
                        $scope.basisFiles.splice(elementIndex, 1);
                    }
                    if (type === 'attachment') {
                        elementIndex = _.findIndex($scope.attachments, function (attachmentFile) {
                            return attachmentFile._id === file._id;
                        });
                        $scope.attachments.splice(elementIndex, 1);
                    }
                    if (type === 'documentFile') {
                        $scope.documentFile = null;
                    }
                    usSpinnerService.stop("root");
                })
            } else {
                usSpinnerService.stop("root");
            }
        };

        $scope.setAddresseeAsVisior = function (addressee) {
            $scope.addressees = $scope.addressees.map(function (a) {
                if (addressee.profile._id === a.profile._id) {
                    a.type = addressee.visior ? 'visa' : null
                }
                return a;
            })
            $scope.addressees = _.sortBy($scope.addressees, 'type');
        };

        $scope.addToAddresseeList = function () {
            if ($scope.addressee) {
                const addressee = $scope.addressee;
                if ($scope.addressees.indexOf(addressee) > -1) {
                    toastr.error('', 'ადრესატი უკვე დამატებულია');
                } else {
                    usSpinnerService.spin("root");
                    Hr.getCurrentVacation(addressee.profile._id).then(function (res) {
                        if (res.vacation) {
                            //todo check vacation
                            addressee.vacation = res.vacation;
                            addressee.performer = res.performer;
                        }
                        $scope.addressees.push(addressee);
                        usSpinnerService.stop("root");
                    });
                }
                $scope.addressee = null;
            }
        };

        $scope.attachmentRequired = function () {
            for (var i in $scope.documentTypes) {
                var filtered = $scope.documentTypes[i].filter(function (el) { return el._id === $scope.type });
                if (filtered.length > 0) {
                    return filtered[0].attachmentRequired || false;
                }
            }
            return false;
        }
    }]);
